import { NgModule } from '@angular/core';
import { IrisOverlayLoaderComponent } from './overlay-loader.component';

@NgModule({
  declarations: [IrisOverlayLoaderComponent],
  exports: [IrisOverlayLoaderComponent],
  imports: [],
})
export class IrisOverlayLoaderComponentModule {}
